import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { canManageSandboxes, isAdminRole } from "@/lib/permissions";

export function ProtectedRoute() {
  const { status, identity } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (status !== "signed_in" || !identity) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Admins (chief/respai_admin) get the dashboard; respai_sales is let in for
  // the sandbox surface only (RES-155) — its landing redirect happens in App.
  if (!isAdminRole(identity.role) && !canManageSandboxes(identity.role)) {
    return <Navigate to="/wrong-app" replace />;
  }

  return <Outlet />;
}
